import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

const DEFAULT_PIPELINE_STATS = { data: null, isLoading: false, error: null };

const selectPipelineStatsState = ({ loanPipelines }) => loanPipelines.pipelineStats;

export const selectPipelineStats = memoizeOne(pipelineId =>
  createSelector(
    [selectPipelineStatsState],
    pipelineStats => pipelineStats[pipelineId] || DEFAULT_PIPELINE_STATS,
  ),
);
